function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useState } from 'react';
import PropTypes from "prop-types";
import Icon from "noood/comp/ui/feather-icon/Icon";
import * as stylex from '@stylexjs/stylex';
export default function ColorIcon(props) {
  var _props$styling, _props$styling2;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    hoverStyle = _useState2[0],
    setHoverStyle = _useState2[1];
  return /*#__PURE__*/React.createElement("div", _extends({
    style: _objectSpread(_objectSpread({
      width: "".concat(props.size, "px"),
      height: "".concat(props.size, "px"),
      borderRadius: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: props.background_color,
      transition: "background-color 0.2s"
    }, (_props$styling = props.styling) === null || _props$styling === void 0 ? void 0 : _props$styling.box), hoverStyle)
  }, stylex.props(props.stylex_container), {
    onMouseEnter: function onMouseEnter(e) {
      var _props$hoverBackgroun;
      setHoverStyle({
        backgroundColor: "".concat((_props$hoverBackgroun = props.hoverBackgroundColor) !== null && _props$hoverBackgroun !== void 0 ? _props$hoverBackgroun : props.background_color)
      });
    },
    onMouseLeave: function onMouseLeave(e) {
      setHoverStyle({});
    },
    onClick: function onClick(e) {
      var _props$__click;
      (_props$__click = props.__click) === null || _props$__click === void 0 || _props$__click.call(props, e);
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    style: _objectSpread({
      color: props.icon_color,
      fontSize: "".concat(props.size * .6, "px")
    }, (_props$styling2 = props.styling) === null || _props$styling2 === void 0 ? void 0 : _props$styling2.icon),
    stylexStyles: props.stylex_icon
  }));
}
ColorIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
  icon_color: PropTypes.string,
  background_color: PropTypes.string,
  __click: PropTypes.func,
  styling: PropTypes.shape({
    icon: PropTypes.object,
    box: PropTypes.object
  }),
  hoverBackgroundColor: PropTypes.string
};
ColorIcon.defaultProps = {
  icon_color: '#ffffff',
  background_color: '#78a63c',
  size: 30
};

// @ts-ignore